export default function HDFCPrivacyPolicy() {
  return <div className="policyContainer">HDFC Privacy Policy</div>;
}
